import { combineReducers } from 'redux';
import Auth from './Auth';
import Theme from './Theme';
import News from './News';

const reducers = combineReducers({
    theme: Theme,
    auth: Auth,
    news: News
});

export default reducers;